"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _react.default.createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}, _react.default.createElement("path", {
  d: "M0 .5C0 .23.23 0 .5 0h15c.27 0 .5.23.5.5v2.84a.5.5 0 01-.2.4l-5.57 4.04v5.35a.5.5 0 01-.2.4L6.91 15.9a.5.5 0 01-.8-.4V8.2L.2 4.08a.5.5 0 01-.2-.41V.5zM1 1v2.42l5.9 4.1c.13.1.2.25.2.41v6.56l2.13-1.6V7.53a.5.5 0 01.2-.4L15 3.07V1H1z"
}));

exports.default = _default;